/** Sidebar menü görünürlüğü — kullanıcı bazlı (localStorage). */

export const MENU_PREFS_STORAGE_KEY = "mbs_sidebar_hidden_v1";

/** Bu yollar menüden gizlenemez (navigasyon güvenliği). */
export const MENU_ALWAYS_VISIBLE = new Set(["/"]);

export function loadHiddenPaths() {
    try {
        const raw = localStorage.getItem(MENU_PREFS_STORAGE_KEY);
        if (!raw) return new Set();
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return new Set(parsed.filter(Boolean));
    } catch (_) {
        /* ignore */
    }
    return new Set();
}

export function saveHiddenPaths(hiddenSet) {
    try {
        localStorage.setItem(MENU_PREFS_STORAGE_KEY, JSON.stringify([...hiddenSet]));
    } catch (_) {
        /* ignore */
    }
}

export function isMenuPathVisible(path, hiddenSet) {
    if (!path) return true;
    if (MENU_ALWAYS_VISIBLE.has(path)) return true;
    return !hiddenSet.has(path);
}

export function setMenuPathVisible(hiddenSet, path, visible) {
    const next = new Set(hiddenSet);
    if (MENU_ALWAYS_VISIBLE.has(path)) return next;
    if (visible) next.delete(path);
    else next.add(path);
    saveHiddenPaths(next);
    return next;
}

export function toggleMenuPathHidden(hiddenSet, path) {
    const visible = isMenuPathVisible(path, hiddenSet);
    return setMenuPathVisible(hiddenSet, path, !visible);
}

export function showAllMenuPaths() {
    const empty = new Set();
    saveHiddenPaths(empty);
    return empty;
}

export function countHiddenInGroup(items, hiddenSet) {
    return items.filter((it) => !isMenuPathVisible(it.path, hiddenSet)).length;
}
